import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

import { DOCUMENTS_URL, DOCUMENTS_DETAIL_URL, DOC_UPLOAD_NEW_URL, DOC_REQUEST_NEW_URL } from 'src/constants/constants.js';
import DocumentsTableContainer from 'src/ui/features/Documents/containers/DocumentsTableContainer';
import DocumentsDetailContainer from 'src/ui/features/Documents/containers/DocumentsDetailContainer';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import withRouter from 'src/utils/withRouter';

//Lazy Load
const DocUpload = lazy(() => import('src/ui/features/Documents/containers/DocUploadContainer'));
const RequestUploadContainer = lazy(() => import('src/ui/features/Documents/containers/RequestUploadContainer'));
const DocUploadWithRouter = withRouter(DocUpload);
const RequestUploadContainerWithRouter = withRouter(RequestUploadContainer);
const DocumentsDetailContainerWithRouter = withRouter(DocumentsDetailContainer);
const DocumentsTableContainerWithRouter = withRouter(DocumentsTableContainer);

const DocumentsLandingPres = () => (
  <Suspense fallback={<ServiceSpinner open={true} />}>
    <Routes>
      <Route
        path={'upload-new/:caseManagerId?/:clientId?/:docGroupId?/:docTypeId?/:caseDocumentTypeId?'}
        element={<DocUploadWithRouter />}
      />
      <Route path={'request-documents/:caseManagerId?/:clientId?/:docGroupId?/:docTypeId?'} element={<RequestUploadContainerWithRouter />} />
      <Route
        path={'detail/:caseManagerId/:documentid/:caseDocumentTypeId/:documentTypeId/:documentGroupId'}
        element={<DocumentsDetailContainerWithRouter />}
      />
      <Route path={'detail/:documentid/:caseDocumentTypeId'} element={<DocumentsDetailContainerWithRouter />} />
      <Route path="*" element={<DocumentsTableContainerWithRouter />} />
    </Routes>
  </Suspense>
);

export default DocumentsLandingPres;
